// components
import maDamageItem from './../damageItem'
import maInputSurface from '@/components/input/modules/text'
import maButtonWhite from '@/components/button-blue'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

// import event Bus
import maEventBus from '@/components/eventbus/index.js'

export default {
  name: 'damagedPart',
  mixins: [flowMixin],

  data() {
    return {
      showDeleteBtn: false
    }
  },

  props: {
    damagedPart: {
      type: Object,
      required: true
    },
    buttonEnable: {
      type: Boolean,
      default: true
    }
  },

  components: {
    maDamageItem,
    maInputSurface,
    maButtonWhite
  },

  methods: {
    handleMoreOptions() {
      this.showDeleteBtn = !this.showDeleteBtn
    },
    handleOnShowModal() {
      this.$emit('openModal', this.damagedPart)
    }
  },
  mounted() {
    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)

    maEventBus.$on('btnDelete:clicked', () => {
      this.showDeleteBtn = false
    })
  }
}
